<template>
  <div id="container">
    <div class="  flex w-full   p-5">
      <div class="vx-col flex items-center justify-center flex-col  mx-auto ">
        <vs-button @click="$emit('close')" size="large">Back</vs-button>


        <div v-if="scannedResult">
          <vx-card>
            <info valueSize="26px" label="Master Stock Code" :value="inventory.masterStockCodeName" />
            <info valueSize="20px" label="Sub Stock Code" :value="inventory.subStockCodeName" />
            <info valueSize="14px" label="Line Description" :value="inventory.lineDescription" />
            <div class="vx-row">
              <div class="vx-col w-1/2   mb-base">
                <info label="Company" :value="inventory.compIdName" />
                <info label="Stock" :value="inventory.stock" />
                <info label="Location" :value="inventory.locationName" />
                <info label="Unit" :value="inventory.unit" />

              </div>
              <div class="vx-col w-1/2 ">

                <info label="Size / Dimension" :value="inventory.sizeDimension" />
                <info label="Thickness" :value="inventory.thickness" />
                <info label="Zone" :value="inventory.zoneName" />
                <info label="Shelf" :value="inventory.shelfName" />
              </div>
            </div>
            <info valueSize="30px" label="Stock Balance" :value="inventory.stockBalance" />

            <updateform :inventory="inventory" @close="$emit('close')">
            </updateform>
          </vx-card>

        </div>

        <div v-else>
          <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import VueQrcodeReader from 'vue-qrcode-reader';
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import { axiosMixin } from '../../mixin/axiosMixin';
import { StreamBarcodeReader } from "vue-barcode-reader";
import { alertMixin } from '../../mixin/alertMixin';
import info from "@/views/inventory/info.vue"
import updateform from "./stocktakeUpdateForm.vue"
export default {
  mixins: [axiosMixin, alertMixin],
  components: {
    StatisticsCardLine,
    StreamBarcodeReader,
    info,
    updateform
  },
  data() {
    return {
      scannedResult: null,
      inventory: {}
    };
  },


  methods: {
    onDecode(text) {
      this.scannedResult = text
      this.getData();
    },
    onLoaded() {
      // alert(`Ready to start scanning barcodes`)
    },
    getData() {
      this.startLoading();
      this.aronPost('getstData', { datacode: this.scannedResult }, '', '')
        .then(response => {
          if (response.status) {
            this.inventory = response.data.inventory;
          } else {
            this.errorAlert('Error', response.data.error)
          }

          this.stopLoading();
        })
        .catch(error => {
          console.log('error:', error);
          this.stopLoading();
        })

    },
    startLoading() {
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      });
    },
    stopLoading() {
      this.$vs.loading.close('#container > .con-vs-loading');
    },


  },
  mounted() {

  },
  created() {

  }
};
</script>
